export default class ChattyDebugCollector {
  constructor(config = {}) {
    this.baseURL = config.baseURL || 'https://api.chatty-pipeline.site';
    this.serverUrl = `${this.baseURL}/api/debug`;
    this.healthUrl = `${this.baseURL}/health`;
    this.enabled = config.enabled !== false;
    this.userId = config.userId || null;
    this.appVersion = config.appVersion || '1.0.0';
    this.environment = config.environment || process.env.NODE_ENV || 'development';
    this.shop = {
      shopId: window.AVADA_APP_FAQS_STATUS?.shopId,
      shopifyDomain: window.Shopify?.shop
    };

    // disable in dev mode
    if (this.environment === 'development') {
      this.enabled = false;
    }

    if (this.enabled) {
      this.init();
    }
  }

  init() {
    window.addEventListener('message', this.handleMessage.bind(this));
    console.log('ChattyDebugCollector initialized');
  }

  async handleMessage(event) {
    if (event.data && event.data.type === 'DEBUG_ERROR') {
      await this.sendError(event.data.payload);
    }
  }

  // Check server health
  async checkHealth() {
    try {
      const response = await fetch(this.healthUrl, {
        method: 'GET',
        timeout: 10000 // 5 second timeout
      });
      return response.ok;
    } catch (error) {
      this.enabled = false;
      console.warn('Debug server health check failed. Disabling ChattyDebugCollector');
      return false;
    }
  }

  // Main error sending method with health check fallback
  async sendError(errorData) {
    if (!this.enabled) return;

    try {
      const deviceInfo = {
        userAgent: navigator.userAgent,
        onLine: navigator.onLine,
        isMobile: /Mobile|Android|iPhone|iPad/.test(navigator.userAgent),
        connectionType: navigator.connection?.effectiveType,
        timezone: new Intl.DateTimeFormat().resolvedOptions().timeZone
      };

      const payload = {
        shop: this.shop,
        device: deviceInfo,
        timestamp: new Date().toISOString(),
        userId: this.userId,
        appVersion: this.appVersion,
        environment: this.environment,
        ...errorData
      };

      const response = await fetch(this.serverUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        console.log('✅ Error sent to debug server:', errorData.message || errorData.error);
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (err) {
      console.warn('❌ Failed to send error to debug server:', err.message);
      // On first failure, check health once
      console.log('🔍 Checking debug server health...');
      await this.checkHealth();
    }
  }
}
